import type {NorafUpdate} from 'api/types';
import type {TypedSchema} from 'schemaDefinition/types';

export const agentNorafUpdateSchema: TypedSchema<NorafUpdate> = {
  name: 'norafUpdate',
  key: 'norafUpdate',
  parts: [
    {
      type: 'text',
      name: 'nationalId',
    },
    {
      type: 'text',
      name: 'name',
    },
    {
      type: 'text',
      name: 'agentType',
    },
    {
      type: 'date',
      name: 'lastUpdated',
    },
  ],
};
